"use client";

import { useEffect } from "react";

export default function ServiceWorkerRegister() {
    useEffect(() => {
        if (typeof window === "undefined") return;
        if (!("serviceWorker" in navigator)) return;

        if (process.env.NODE_ENV !== "production") {
            navigator.serviceWorker.getRegistrations().then((regs) => {
                for (const reg of regs) reg.unregister().catch(() => {});
            });
            if (typeof caches !== "undefined") {
                caches.keys().then((keys) => {
                    for (const k of keys) caches.delete(k).catch(() => {});
                });
            }
            return;
        }

        const onLoad = () => {
            navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
        };

        if (document.readyState === "complete") onLoad();
        else window.addEventListener("load", onLoad, { once: true });

        return () => window.removeEventListener("load", onLoad);
    }, []);

    return null;
}
